export const optionsData = data => {
  if (data) {
    const options = data
    return options
  }
  // for (let i = 0; i < 50; ++i) {
  //   options.push({
  //     value: i + 1,
  //     label: `Option ${i + 1}`,
  //   })
  // }
}
const sleep = ms =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, ms)
  })
export default async function loadOptions(search, prevOptions) {
  await sleep(1000)
  const options = optionsData()
  let filteredOptions
  if (!search) {
    if (options) {
      filteredOptions = options
    }
  } else {
    const searchLower = search.toLowerCase()
    filteredOptions = options.filter(({ label }) =>
      label.toLowerCase().includes(searchLower)
    )
  }

  const hasMore = filteredOptions.length > prevOptions.length + 10
  const slicedOptions = filteredOptions.slice(
    prevOptions.length,
    prevOptions.length + 10
  )
  return {
    options: slicedOptions,
    hasMore,
  }
}
